module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "field"
  }, [(_vm.isTag1Active) ? _c('b-tag', {
    attrs: {
      "type": "is-primary",
      "closable": "",
      "aria-close-label": "Close tag"
    },
    on: {
      "close": function($event) {
        _vm.isTag1Active = false
      }
    }
  }, [_vm._v("\n                Colored closable tag label\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [(_vm.isTag2Active) ? _c('b-tag', {
    attrs: {
      "attached": "",
      "closable": "",
      "aria-close-label": "Close tag"
    },
    on: {
      "close": function($event) {
        _vm.isTag2Active = false
      }
    }
  }, [_vm._v("\n                Attached closable tag label\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [(_vm.isTag3Active) ? _c('b-tag', {
    attrs: {
      "type": "is-danger",
      "attached": "",
      "closable": "",
      "aria-close-label": "Close tag"
    },
    on: {
      "close": function($event) {
        _vm.isTag3Active = false
      }
    }
  }, [_vm._v("\n                Colored attached closable tag label\n            ")]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b5966ee"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/tag/examples/ExClosable.vue
// module id = 1245
// module chunks = 16 76